export default __webpack_public_path__ + "static/media/black_kite.8d8ebba3.jpg";